export type LessonNavItem = {
  title: string;
  items: LessonNavSubItem[];
};

export type LessonNavSubItem = {
  id: number;
  title: string;
};

export interface LessonContent {
  content: LessonPageGroup[];
  exemplar: string;
  json_version: string;
  pages: string;
}

export interface LessonPageGroup {
  type: string;
  title: string;
  content: LessonPage[];
}

export interface LessonPage {
  id: number;
  type: string;
  title: string;
  audience: string[];
  content: Array<LessonPageText | LessonPageHeading | LessonPageWrapper | LessonPageTable>;
}

export interface LessonPageText {
  type: string;
  text: string;
  links?: LessonPageLink[];
  icon?: LessonPageIcon;
}

export interface LessonPageHeading {
  type: string;
  text: string;
  icon?: LessonPageIcon;
}

export interface LessonPageWrapper {
  type: string;
  style?: LessonPageWrapperStyles[];
  content: Array<LessonPageHeading | LessonPageText>;
}

export interface LessonPageTable {
  type: string;
  text: string;
  style?: LessonPageTableStyles[];
  rows: LessonPageTableRow[];
}

export type LessonPageLink = LessonPageExemplarLink | LessonPageDocumentLink | LessonPageVideoLink | LessonPageIWPLink;

interface LessonPageExemplarLink {
  type: LessonPageLinkType.exemplar;
  text: string;
  exemplarId: number;
  screen: string;
  stage: string;
}

interface LessonPageDocumentLink {
  type: LessonPageLinkType.document;
  text: string;
  url: string;
  filename: string;
}

interface LessonPageVideoLink {
  type: LessonPageLinkType.video;
  text: string;
  url: string;
  filename: string;
}

interface LessonPageIWPLink {
  type: LessonPageLinkType.iwp;
  text: string;
}

export interface LessonPdf {
  description: string;
  links: {
    self: string;
  };
  stages: string[];
  title: string;
  type: string;
}

export interface LessonPageTableRow {
  type: string;
  content: Array<LessonPageHeading | LessonPageText>;
}

export enum LessonPageIcon {
  assessment = 'assessment',
  checkIn = 'check-in',
  flexible = 'flexible',
  star = 'star',
  T = 'T',
  A = 'A',
  B = 'B',
}

export enum LessonPageLinkType {
  exemplar = 'exemplar',
  iwp = 'iwp',
  document = 'document',
  video = 'video',
}

export enum LessonPageTableStyles {
  towardsAtBeyond = 'TowardsAtBeyond',
}

export enum LessonPageWrapperStyles {
  learningIntentionSuccessCriteria = 'LearningIntentionSuccessCriteria',
  importantTeachingPoint = 'ImportantTeachingPoint',
}
